import {Typography, TypographyProps} from "@mui/material";
import {PropsWithChildren} from "react";

export const SectionHeaderTypography = (props: PropsWithChildren<TypographyProps>) => {
    const {children} = props

    return <Typography  className={'section-header-typography'} component={'h2'}>{children}</Typography>

}